import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
var BsDatepickerNavigationViewComponent = (function () {
    function BsDatepickerNavigationViewComponent() {
        this.onNavigate = new EventEmitter();
    }
    BsDatepickerNavigationViewComponent.prototype.navTo = function (step) {
        this.onNavigate.emit({ step: step });
    };
    BsDatepickerNavigationViewComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bs-datepicker-navigation-view',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: "\n    <button class=\"previous\"\n            [style.visibility]=\"month.hideLeftArrow ? 'hidden' : 'visible'\"\n            (click)=\"navTo({month: -1})\"><span>&lsaquo;</span>\n    </button>\n    <button class=\"current\"><span>{{ month.monthTitle }}</span>\n    </button>\n    <button class=\"current\"><span>{{ month.yearTitle }}</span>\n    </button>\n    <button class=\"next\"\n            [style.visibility]=\"month.hideRightArrow ? 'hidden' : 'visible'\"\n            (click)=\"navTo({month: 1})\"><span>&rsaquo;</span>\n    </button>\n  "
                },] },
    ];
    /** @nocollapse */
    BsDatepickerNavigationViewComponent.ctorParameters = function () { return []; };
    BsDatepickerNavigationViewComponent.propDecorators = {
        'month': [{ type: Input },],
        'onNavigate': [{ type: Output },],
    };
    return BsDatepickerNavigationViewComponent;
}());
export { BsDatepickerNavigationViewComponent };
//# sourceMappingURL=bs-datepicker-navigation-view.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/themes/bs/bs-datepicker-navigation-view.component.js
// module id = 873
// module chunks = 103